import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "buttonText", "arrow"]
  static values = { 
    isOpen: { type: Boolean, default: false }
  }

  connect() {
    // Find all instances of this controller
    // Using the attribute selector [data-controller~="toggle-billing-features"] to handle multiple controllers
    this.allControllers = document.querySelectorAll('[data-controller~="toggle-billing-features"]')
  }

  toggle() {
    // Update the state
    this.isOpenValue = !this.isOpenValue
    
    // Update all cards
    this.allControllers.forEach(card => {
      const controller = this.application.getControllerForElementAndIdentifier(card, "toggle-billing-features")
      if (controller) {
        // Update content visibility
        controller.contentTarget.classList.toggle("hidden", !this.isOpenValue)
        
        // Update button text
        controller.buttonTextTarget.textContent = this.isOpenValue ? "Hide Features" : "Show Features"
        
        // Rotate arrow
        controller.arrowTarget.style.transform = this.isOpenValue ? "rotate(180deg)" : ""
        
        // Sync the state
        controller.isOpenValue = this.isOpenValue
      }
    })
  }
} 